<template>
  <ul v-if="pager.pages && pager.pages.length">
    <li class="first-page" :class="{ disabled: pager.currentPage === 1 }">
      <a href="javascript:;" @click="setPage(1)">{{ $t('pagination.the_first') }}</a>
    </li>
    <li class="prev-page" :class="{ disabled: pager.currentPage === 1 }">
      <a href="javascript:;" @click="setPage(pager.currentPage - 1)">{{ $t('pagination.previous') }}</a>
    </li>
    <li
      v-for="page in pager.pages"
      :key="page"
      :class="[pager.currentPage === page ? 'number-page-active' : 'number-page']"
    >
      <a href="javascript:" @click="setPage(page)">{{ page }}</a>
    </li>
    <li class="next-page" :class="{ disabled: pager.currentPage === pager.totalPages }" @click="setPage(pager.currentPage + 1)">
      <a href="javascript:;">{{ $t('pagination.next') }}</a>
    </li>
    <li class="last-page" :class="{ disabled: pager.currentPage === pager.totalPages }">
      <a href="javascript:;" @click="setPage(pager.totalPages)">{{ $t('pagination.the_last') }}</a>
    </li>
  </ul>
</template>

<script>
import paginate from "jw-paginate"
const options = {
  maxPages: 4
}

export default {
  props: {
    items: {
      type: Array,
      required: true
    },
    initialPage: {
      type: Number,
      default: 1
    },
    pageSize: {
      type: Number,
      default: 10
    }
  },
  data() {
    return {
      pager: {}
    }
  },
  created() {
    this.setPage(this.initialPage)
  },
  methods: {
    setPage(page) {
      const { items, pageSize, maxPages } = this
      const pager = paginate(items.length, page, pageSize, options.maxPages)
      const pageOfItems = items.slice(pager.startIndex, pager.endIndex + 1)
      this.pager = pager
      if(this.$route.path !== '/notifications/region' && this.$route.path !== '/notifications/management') {
        this.$store.dispatch('notification/setCurrentPage', page)
      }
      this.$emit("changePage", pageOfItems)
    }
  },
  watch: {
    items() {
      this.setPage(this.initialPage)
    },
    pageSize() {
      this.setPage(this.initialPage)
    }
  }
}
</script>
